import ActionMenu from "@/v2-backoffice-client/components/actionMenu"
import FeatureRenameMenuItem from "@/v2-backoffice-client/feature/rename/FeatureRenameMenuItem"

export type LayerCategoryActionMenuProps = {
  /**
   * Requests the rename dialog. The dialog is owned by the TABLE, not this
   * menu: the row toolbar only exists while its row is hovered or holds an
   * open menu, so anything mounted here dies the moment the menu closes.
   */
  onRename(): void
}

function LayerCategoryActionMenu(props: LayerCategoryActionMenuProps) {
  const { onRename } = props

  return (
    <ActionMenu>
      <ActionMenu.Trigger />

      <ActionMenu.Content>
        <FeatureRenameMenuItem
          dataFeatureCode="UI_BackofficeLayerCategories_Rename_MenuItem"
          onSelect={onRename}
        />
      </ActionMenu.Content>
    </ActionMenu>
  )
}

export default LayerCategoryActionMenu
